import { ApiClient } from '../../Shared/interfaces/ApiClient';
import {
    BookingDetails, EditBookingPayload
} from '../components/CreateBooking/interface/BookingFormInterface';

import { ENDPOINTS } from '../constants/endpoints';

const {
  GET_ACCOUNT_EXECUTIVES,
  GET_ACCOUNT_MANAGERS,
  GET_TYPE_OF_PURCHASE_LIST,
  GET_ADVERTISERS,
  BOOKINGS_ENDPOINT,
  GET_SLOT_PACKAGES,
  CHECK_INVENTORY_EXIST
} = ENDPOINTS;

export const getAccountExecutives = (api: ApiClient) =>
  api.get(GET_ACCOUNT_EXECUTIVES);

export const getAccountManagers = (api: ApiClient) =>
  api.get(GET_ACCOUNT_MANAGERS);

export const getTypeOfPurchaseList = (api: ApiClient) =>
  api.get(GET_TYPE_OF_PURCHASE_LIST);

export const getAdvertisers = (
  api: ApiClient,
  categoryName: string,
  orgName: string
) => {
  const params = new URLSearchParams({ categoryName, orgName });
  return api.get(
    `${GET_ADVERTISERS}?${params}`
  );
};

export const createBookingApi = (api: ApiClient, payload: BookingDetails['booking']) => api.post(BOOKINGS_ENDPOINT, {
  booking: payload,
});

export const getBookingDetailsById = async (
  api: ApiClient,
  bookingId: string
) => api.get(`${BOOKINGS_ENDPOINT}/${bookingId}`);

// Function to edit booking basic information (only editable fields)
export const editBookingDetails = (api: ApiClient,
  bookingId: string, payload: EditBookingPayload['booking']) => api.put(`${BOOKINGS_ENDPOINT}/${bookingId}`, {
    booking: payload,
  });

// Function to update booking with only contextual nodes data
export const updateContextualNodes = async (
  api: ApiClient,
  bookingId: string,
  contextualNodesData: EditBookingPayload['booking']['contextualNodes']
) => {
  const payload = {
    booking: {
      contextualNodes: contextualNodesData,
    },
  };

  return api.put(`${BOOKINGS_ENDPOINT}/${bookingId}`, payload);
};

export const getSlotPackages = async (api: ApiClient, typeOfPurchase: string, artEventId: string) => {
  const params = new URLSearchParams({ typeOfPurchase, artEventId })
  return api.get(`${GET_SLOT_PACKAGES}?${params}`);
}
